export const SettingsOnboarding = [
  {
    title: "Personaliza la información de tu empresa",
    description:
      "Edita la información general de tu empresa, añade las cuentas bancarias en las que manejas tu dinero, sube el logotipo de tu empresa y define el pie de página de tus facturas ventas.",
    image: "https://cdn01.prd.symfonia.io/Gifs/Configuración.gif",
    alt: "Configuración",
  },
];
